export const isMobile = () => {
  const isIframe = window?.top !== window?.self
  const isMobileDevice = /iPhone|iPod|Android/i.test(navigator.userAgent)
  return isIframe || isMobileDevice
}

export const isAppleDevice = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent)

export const isInstalledPWA = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  (window.navigator as Navigator & { standalone?: boolean }).standalone === true

export const shouldPromptIOSInstall = () => isIOS() && !isInstalledPWA()
